import api from '@/api/coupon'
import { bindCard as gotoBindCard, bindCardV2 } from '@/api/bank'
export const state = {
  avaliableMore: false,
  avaliable: [],
  avaliablePage: 1,
  invalidMore: false,
  invalid: [],
  invalidPage: 1,
  coupon: {},
  confirm: false,
  errShow: false,
  errMessage: '',
  bankCard: {
      cardNo: '',
      bankName: ''
  },
  lastCoupon: {},
  showLast: false,
  settingCard: false,
  bindCard: false,
  cbType: 0,
};

export const mutations = {
  'SET_AVALIABLE_COUPONS_LIST' (state, payload) {
    state.avaliable = payload;
  },
  'ADD_AVALIABLE_COUPONS_LIST' (state, payload) {
    state.avaliable = state.avaliable.concat(payload);
  },
  'SET_INVALID_COUPONS_LIST' (state, payload) {
    state.invalid = payload;
  },
  'ADD_INVALID_COUPONS_LIST' (state, payload) {
    state.invalid = state.invalid.concat(payload);
  },
  'SET_COUPON' (state, payload) {
    state.coupon = payload;
  },
  'SET_CONFIRM' (state, payload) {
    state.confirm = payload;
  },
  'SET_BANK_CARD_INFO' (state, payload) {
    if (payload) {
      state.bankCard = payload;
    } else {
      state.bankCard = {
        cardNo: '',
        bankName: ''
      };
    }
  },
  'SET_ERROR_SHOW' (state, payload) {
    let { msg, show, cbType } = payload;
    state.errShow = show;
    state.cbType = cbType || 0;
    if (!show) {
      state.errMessage = '';
    } else {
      state.errMessage = msg;
    }
  },
  'SET_LAST_COUPON' (state, coupon) {
    state.lastCoupon = coupon;
  },
  'SET_AVALIABLE_PAGE' (state, payload) {
    state.avaliablePage = payload;
  },
  'SET_INVALID_PAGE' (state, payload) {
    state.invalidPage = payload;
  },
  'SET_COUPON_TYPE' (state) {
    if (state.coupon.type) {
      state.coupon.type = 1;
    }
  },
  'SET_SETTING_CARD' (state, payload) {
    state.settingCard = payload;
  },
  'SET_BIND_CARD' (state, payload) {
    state.bindCard = payload;
  },
  'SET_LAST_COUPON_SHOW' (state, payload) {
    state.showLast = payload;
  },
  'CHANGE_COUPON_LIST' (state) {
    var coupon = null;
    for (var i = state.avaliable.length - 1; i >= 0; i--) {
      if (state.avaliable[i].couponId == state.coupon.couponId) {
        coupon = state.avaliable.splice(i, 1);
        break;
      }
    }
    state.invalid = state.invalid.concat(coupon);
  },
  'RESET_COUPON' (state) {
    state.avaliableMore = false
    state.avaliable = []
    state.avaliablePage = 1
    state.invalidMore = false
    state.invalid = []
    state.invalidPage = 1
    state.coupon = {}
    state.confirm = false
    state.errShow = false
    state.errMessage = ''
    state.bankCard = {
        cardNo: '',
        bankName: ''
    }
    state.lastCoupon = {}
    state.showLast = false
    state.settingCard = false
    state.bindCard = false
    state.cbType = 0
  }
};

export const actions = {
  getAvaliableCoupons ({ state, commit }, payload) {
    if (!isNaN(payload)) {
      api.getAvaliableCoupons(payload)
      .then(data => {
        commit('SET_AVALIABLE_COUPONS_LIST', state.avaliable.concat(data));
      }, err => {
        commit('SET_ERROR_SHOW', {
          show: true,
          msg: err.message
        })
      })
    } else if (state.avaliable.length == 0) {
      api.getAvaliableCoupons(1)
      .then(data => {
        commit('SET_AVALIABLE_COUPONS_LIST', data);
      }, err => {
        commit('SET_ERROR_SHOW', {
          show: true,
          msg: err.message
        })
      })
    }
  },
  getNextAvaliableCoupons ({ state, commit, dispatch }, page) {
    commit('SET_AVALIABLE_PAGE', page);
    dispatch('getAvaliableCoupons', state.avaliablePage);
  },
  getInvalidCoupons({ state, commit }, payload) {
    if (!isNaN(payload)) {
      api.getInvalidCoupons(payload)
      .then(data => {
        commit('SET_INVALID_COUPONS_LIST', state.invalid.concat(data));
      }, err => {
        commit('SET_ERROR_SHOW', {
          show: true,
          msg: err.message
        })
      })
    } else if (state.invalid.length == 0) {
      api.getInvalidCoupons(1)
      .then(data => {
        commit('SET_INVALID_COUPONS_LIST', data);
      }, err => {
        commit('SET_ERROR_SHOW', {
          show: true,
          msg: err.message
        })
      })
    }
  },
  getNextInvalidCoupons ({ state, commit, dispatch }, page) {
    commit('SET_INVALID_PAGE', page);
    dispatch('getInvalidCoupons', state.invalidPage);
  },
  getCoupon ({state, commit}, payload) {
    let list = state.invalid.concat(state.avaliable);
    for (var i = list.length - 1; i >= 0; i--) {
      var c = list[i];
      if (c.couponId == payload) {
        commit('SET_COUPON', c);
        return;
      }
    }
    api.getCoupon(payload)
    .then(data => {
      commit('SET_COUPON', data);
    }, err => {
      commit('SET_ERROR_SHOW', {
        show: true,
        message: err.message
      })
    })
  },
  bankCardState ({commit}) {
    api.bankCardState()
    .then(data => {
      // 0:有默认还款卡，1:有还款卡，但无默认还款卡，2:无还款卡
      if (data.type == 0) {
        commit('SET_BANK_CARD_INFO', data);
        commit('SET_CONFIRM', true);
      } else {
        commit('SET_CONFIRM', false);
        commit('SET_BANK_CARD_INFO')
      }

      if (data.type == 1) {
        // todo 设置自动还款卡
        commit('SET_SETTING_CARD', true);
      } else if (data.type == 2) {
        // todo 新增还款卡
        commit('SET_BIND_CARD', true);
      }
    }, err => {
      commit('SET_ERROR_SHOW', {
        show: true,
        msg: err.message
      })
    })
  },
  consume ({state, commit}) {
    commit('SET_CONFIRM', false);
    api.consume(state.coupon.couponId)
    .then(() => {
      commit('SET_COUPON_TYPE');
      commit('CHANGE_COUPON_LIST');
    }, err => {
      commit('SET_ERROR_SHOW', {
        show: true,
        msg: err.message,
        cbType: 1
      })
    })
  },
  couponLast ({ commit }) {
    api.couponLast()
    .then(data => {
      if (data.length > 0) {
        commit('SET_LAST_COUPON', data[0]);
        commit('SET_LAST_COUPON_SHOW', true);
      } else {
        commit('SET_LAST_COUPON_SHOW', false);
      }
    }, () => {
      commit('SET_LAST_COUPON_SHOW', false);
    })
  },
  gotoBindCard ({ commit }, payload) {
    gotoBindCard(payload.callback || window.location.href, payload.setDefaultCard || false)
    .then((data) => {
      window.location.href = data.redirectUrl;
    }, (err) => {
      commit('SET_ERROR_SHOW', {
        show: true,
        msg: err.message
      })
    });
  },
  gotoBindCardV2 ({ commit }, payload) {
    return bindCardV2(payload)
  },
};

export default {
  state,
  mutations,
  actions
}